import type { CustomerOrderStep } from "../../data/customerData";

interface CustomerOrderTimelineProps {
  steps: CustomerOrderStep[];
  dark?: boolean;
}

export function CustomerOrderTimeline({ steps, dark = false }: CustomerOrderTimelineProps) {
  return (
    <div className="grid gap-3">
      {steps.map((step) => (
        <div key={step.id} className="grid grid-cols-[0.95rem_minmax(0,1fr)] items-center gap-3">
          <div
            className={[
              "h-3 w-3 rounded-full transition duration-300",
              step.complete
                ? dark
                  ? "bg-teal-300 shadow-[0_0_0_6px_rgba(94,234,212,0.12)]"
                  : "bg-teal-700 shadow-[0_0_0_6px_rgba(21,93,95,0.1)]"
                : dark
                  ? "bg-white/18"
                  : "bg-stone-300"
            ].join(" ")}
          />
          <p
            className={[
              "text-sm leading-6",
              step.complete
                ? dark
                  ? "text-stone-50"
                  : "text-stone-950"
                : dark
                  ? "text-stone-300"
                  : "text-stone-500"
            ].join(" ")}
          >
            {step.label}
          </p>
        </div>
      ))}
    </div>
  );
}
